import React, { useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import Header from "../components/Header"

const Contact: React.FC = () => {
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<Header />
			<div className="container mx-auto mt-6 max-w-[400px] py-8 px-4 text-center   ">
				<h2 className="h2 text-yellow">Kontakt</h2>
				<p className=" mb-4">
					Du hast eine Frage, Anregungen oder Kritik?
					<br />
					<br />
					Dann nimm gerne Kontakt mit uns auf. Wir freuen uns über Deine Nachricht!
					<br />
					<br />
					<a
						href="mailto:intuition@gewinnspiel-2026.de"
						className="underline"
						onClick={() => {
							try {
								// eslint-disable-next-line
								let dataLayer = window["dataLayer"] || []
								dataLayer.push({ event: "contact", link: "mail" })
							} catch (e) {}
						}}
					>
						intuition@gewinnspiel-2026.de
					</a>
					<br />
					<br />
					Allgemeine Informationen zur Aktion findest du außerdem in den{" "}
					<Link
						to="/teilnahmebedingungen"
						target={"_blank"}
						className="underline"
						onClick={() => {
							try {
								// eslint-disable-next-line
								let dataLayer = window["dataLayer"] || []
								dataLayer.push({ event: "contact", link: "faq" })
							} catch (e) {}
						}}
					>
						Teilnahmebedingungen
					</Link>
					.
				</p>
			</div>
			<div className="py-10 pt-5 text-center  ">
				<button onClick={() => navigate(-1)} className="btn btn-yellow">
					Zurück
				</button>
			</div>
		</>
	)
}
export default Contact
